import React, { useContext, useEffect, useState } from "react";

import "../styles/createUser.css";
import Swal from "sweetalert2";
import Multiselect from "multiselect-react-dropdown";
import { UrlContext } from "../contexts/UrlContext";

export default function CreateUser({ setShowCreateUser }) {
  useEffect(() => {
    document.title = "Create User";
  }, []);
  const { API_URL } = useContext(UrlContext);
  const [showPassword, setShowPassword] = useState(false);
  const [eyeSlash, setEyeSlash] = useState(false);
  const [userData, setUserData] = useState({
    fullName: "",
    username: "",
    email: "",
    password: "",
    path: "",
    path_z: "",
    email_z: "",
    roles: "",
  });
  const [role, setRole] = useState([
    { name: "Admin", id: "Admin" },
    { name: "IT", id: "IT" },
    { name: "Project Owner", id: "Project Owner" },
    { name: "Project Supporter", id: "Project Supporter" },
    { name: "Tester", id: "Tester" },
    { name: "HR", id: "HR" },
    { name: "Accounting", id: "Accounting" },
    { name: "Demo", id: "Demo" },
  ]);

  const createUserHandler = (e) => {
    e.preventDefault();
    const url = `${API_URL}create-user`;
    const ephToken = localStorage.getItem("eph-token");
    const token = JSON.parse(ephToken).value;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify(userData),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          Swal.fire({
            title: "Success!",
            text: "User created successfully",
            icon: "success",
            confirmButtonText: "Ok",
          });
          setUserData({
            fullName: "",
            username: "",
            email: "",
            password: "",
            path: "",
            path_z: "",
            email_z: "",
            roles: "",
          });
          window.location.reload();
        } else if (data.status === "error") {
          Swal.fire({
            title: "Error!",
            text: "Username already exists",
            icon: "error",
            confirmButtonText: "Ok",
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      <div className="container-div">
        <form onSubmit={createUserHandler}>
          <div className="user-register-div">
            <h3>Create New User</h3>
            <div className="user-details-boxes">
              <div className="user-input-box">
                <span className="user-label-details">Full Name</span>
                <input
                  placeholder="Enter full name"
                  value={userData.fullName}
                  onChange={(e) =>
                    setUserData({ ...userData, fullName: e.target.value })
                  }
                />
              </div>
              <div className="user-input-box">
                <span className="user-label-details">Username*</span>
                <input
                  placeholder="Enter username"
                  value={userData.username}
                  onChange={(e) =>
                    setUserData({ ...userData, username: e.target.value })
                  }
                  required
                />
              </div>
              <div className="user-input-box">
                <span className="user-label-details">Email</span>
                <input
                  type="email"
                  placeholder="Enter email"
                  value={userData.email}
                  onChange={(e) =>
                    setUserData({ ...userData, email: e.target.value })
                  }
                />
              </div>
              <div className="user-input-box">
                <span className="user-label-details">Role</span>
                <Multiselect
                  options={role}
                  displayValue="name"
                  placeholder="Select Role"
                  closeIcon="cancel"
                  onSelect={(selectedList, selectedItem) => {
                    setUserData({ ...userData, roles: selectedList });
                  }}
                  onRemove={(selectedList, removedItem) => {
                    setUserData({ ...userData, roles: selectedList });
                  }}
                  style={{
                    chips: {
                      background: "#365561",
                    },
                    searchBox: {
                      width: "100%",
                    },
                    multiselectContainer: {
                      width: "100%",
                    },
                    optionContainer: {
                      marginTop: "-21px",
                    },
                  }}
                />
              </div>
            </div>
            <button className="btn base-btn register-btn">Register</button>
            <button
              className="btn base-btn cancel-btn"
              onClick={() => setShowCreateUser(false)}
              style={{
                marginLeft: "10px",
              }}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
